export default __webpack_public_path__ + "static/media/Hendel-Leiva.4aa51a13.jpg";